// extracted by mini-css-extract-plugin
module.exports = {"select":"select__styles__select--3kdmLneO","container":"select__styles__container--1GjCmwrD","icon":"select__styles__icon--1i1EiUvA"};